import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: '1',
    margin: 0,

    [theme.breakpoints.down('sm')]: {
      margin: '0.5rem 0'
    }
  },

  icon: {
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    marginLeft: '1.125rem',
    marginRight: '0.4375rem',
    height: '100%',
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
      marginLeft: '0.625rem'
    }
  },

  children: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.4375rem'
  },

  input: {
    outline: 'none',
    border: 'none',
    margin: '7px 0',
    color: theme.palette.textLight,
    width: ({ fullWidth }) => `${fullWidth ? 100 : 95}%`,
    fontSize: theme.size.sm
  }
}))

export default useStyles
